var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Avatar_-_ikona",
    "data-name": "Avatar - ikona",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1783",
    "data-name": "Rectangle 1783",
    width: 60,
    height: 60,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4965",
    "data-name": "Group 4965",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3694",
    "data-name": "Path 3694",
    d: "M60,30A30,30,0,1,1,30,0,30,30,0,0,1,60,30",
    transform: "translate(0 0.001)",
    fill: "#f2af0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3695",
    "data-name": "Path 3695",
    d: "M23.651,49.417a5.607,5.607,0,0,1-.661.022c-4.335-.115-7.727-5.285-7.563-11.524a.849.849,0,1,1,1.7.045c-.14,5.3,2.511,9.692,5.91,9.782s6.279-4.153,6.419-9.456a.849.849,0,0,1,1.7.045c-.157,5.92-3.46,10.708-7.5,11.086",
    transform: "translate(-8.16 -19.625)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3696",
    "data-name": "Path 3696",
    d: "M76.866,49.807a5.665,5.665,0,0,1-.682.023,6.909,6.909,0,0,1-5.573-3.592,14.271,14.271,0,0,1-1.989-7.932.849.849,0,0,1,1.7.045,12.562,12.562,0,0,0,1.727,6.98,4.711,4.711,0,0,0,8.509.225,12.566,12.566,0,0,0,2.093-6.879.849.849,0,0,1,1.7.045,14.262,14.262,0,0,1-2.406,7.816,7.151,7.151,0,0,1-5.073,3.27",
    transform: "translate(-36.307 -19.831)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3697",
    "data-name": "Path 3697",
    d: "M50.8,67.272a6.5,6.5,0,0,1-3.918-1.253.706.706,0,1,1,.846-1.131,5.413,5.413,0,0,0,4.514.8A6.42,6.42,0,0,0,56.5,62.393a.706.706,0,1,1,1.263.63,7.845,7.845,0,0,1-5.191,4.038,7.671,7.671,0,0,1-1.769.21",
    transform: "translate(-24.659 -32.808)",
    fill: "#1d1d1b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.30ccea6d125f14e36e579e31b8bc3bbd.svg";
export { ForwardRef as ReactComponent };